export const pricingData = [
    {
        id: 'starter',
        title: 'Starter – iOS MVP Launch',
        price: '$15k–$20k',
        for: 'For: Funded startups shipping their first iOS app',
        features: [
            'Native iOS app (Swift/SwiftUI)',
            '4–6 core screens with clean UI',
            'MVVM architecture that won\'t break when you add features',
            'TestFlight beta + App Store submission',
            'Basic analytics (track user behavior)',
            '2 weeks post-launch bug fixes'
        ],
        timeline: '4–6 weeks from kickoff to App Store',
        example: 'My-Advisor – private AI chat app with on-device ML in 5 weeks',
        deposit: '$7.5k deposit',
        depositNote: '(fully credited toward total project cost)',
        stripeLink: 'https://buy.stripe.com/5kQ8wP1Yrcr4gLH4F6gbm02',
        consultationLink: 'https://calendly.com/vermresearch-proton/30min'
    },
    {
        id: 'growth',
        title: 'Growth – Full-Featured iOS Product',
        price: '$20k–$35k',
        for: 'For: Businesses launching polished, revenue-ready iOS apps',
        popular: true,
        features: [
            'Everything in Starter, plus:',
            'Custom backend/API integration (your data, not just static screens)',
            'Advanced UI/UX (animations, gestures, premium feel)',
            'Push notifications + engagement features',
            'In-app purchases or subscriptions (if monetizing)',
            'User authentication (Sign in with Apple, email, social)',
            'Analytics + event tracking',
            '3 months post-launch support (bugs, updates, small features)'
        ],
        timeline: '6–10 weeks',
        example: 'Readdy – reading habit app with gamification, launched to 4.9-star rating',
        deposit: '$10k deposit',
        depositNote: '(fully credited toward total project cost)',
        stripeLink: 'https://buy.stripe.com/8x24gz9qTfDganj1sUgbm03',
        consultationLink: 'https://calendly.com/vermresearch-proton/30min'
    },
    {
        id: 'enterprise',
        title: 'Enterprise – Complex iOS Solutions',
        price: 'Custom Pricing',
        for: 'For: Advanced apps with AI/ML, hardware integration, or complex requirements',
        features: [
            'Everything in Growth, plus:',
            'AI/ML integration (Core ML, on-device models)',
            'Real-time sync / offline-first architecture',
            'Hardware/IoT integration (robotics, wearables, sensors)',
            'Enterprise security/compliance',
            'Dedicated project manager',
            'SLA + priority support'
        ],
        example: 'Built AI chat app with fully on-device LLM – zero server calls, complete privacy',
        consultationLink: 'https://calendly.com/vermresearch-proton/30min',
        custom: true
    }
]
